const curdGenerator = entity => ({
  module: entity,
  children: [
    {
      module: "Add",
      permission: `${entity.toLowerCase().replace(/\s+/g, "")}.add`
    },
    {
      module: "Edit",
      permission: `${entity.toLowerCase().replace(/\s+/g, "")}.edit`
    },
    {
      module: "Delete",
      permission: `${entity.toLowerCase().replace(/\s+/g, "")}.delete`
    },
    {
      module: "List",
      permission: `${entity.toLowerCase().replace(/\s+/g, "")}.list`
    },
    {
      module: "View",
      permission: `${entity.toLowerCase().replace(/\s+/g, "")}.view`
    }
  ]
});

export default curdGenerator;
